'use client'

import React from 'react'

import { Logo } from 'components/ui'
import { useUserContext } from '@/contexts/user'
import Navigation from 'compositions/Navigation/Navigation'
import LiveSwitcher from 'compositions/LiveSwitcher/LiveSwitcher'
import StaticNavigation from 'compositions/Navigation/StaticNavigation/StaticNavigation'
import { useIsMounted } from '@/hooks'

const LeftSidebar: React.FC = () => {
  const { isLoginComplete } = useUserContext()
  const isMounted = useIsMounted()

  const customeHeight = !isMounted()
    ? 'calc(100vh - 14.2rem)'
    : isLoginComplete
      ? 'calc(100vh - 16.2rem)'
      : 'calc(100vh - 14.2rem)'

  return (
    <div className="h-full bg-accent-grey-980">
      <div className="px-6 pr-2 py-5 sticky top-0 flex items-center justify-between bg-accent-grey-980 z-20">
        <Logo className="h-6" />
        {/* <button className="text-accent-grey-200 hover:text-accent-grey-30 transition" onClick={() => openModal('SearchModal')}>
          <Icon className="size-5" name="interface/search" />
        </button> */}
      </div>
      <div
        className="overflow-auto no-scrollbar relative p-2 h-full"
        style={{
          height: customeHeight,
        }}
      >
        <LiveSwitcher />
        <Navigation className="mt-2" />
      </div>
      <StaticNavigation />
    </div>
  )
}

export default LeftSidebar
